import { render, staticRenderFns } from "./FormSaveError.vue?vue&type=template&id=b5711e40&scoped=true&"
import script from "./FormSaveError.vue?vue&type=script&lang=js&"
export * from "./FormSaveError.vue?vue&type=script&lang=js&"
import style0 from "./FormSaveError.vue?vue&type=style&index=0&id=b5711e40&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../morphology/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5711e40",
  null
  
)

export default component.exports